import React from 'react';
import useScreenSize from '../hooks/useScreenSize';

const DetailItem = ({ icon: Icon, label, value }) => {
  const { isMobile } = useScreenSize();

  return (
    <div className="flex items-center justify-between">
      <div className="flex items-center space-x-3">
        <div className={`${isMobile ? 'w-7 h-7' : 'w-8 h-8'} rounded-lg bg-blue-50 flex items-center justify-center`}>
          <Icon className={`${isMobile ? 'w-3.5 h-3.5' : 'w-4 h-4'} text-blue-600`} />
        </div>
        <span className={`${isMobile ? 'text-sm' : ''} text-gray-600`}>{label}</span>
      </div>
      <span className={`${isMobile ? 'text-sm' : ''} font-medium text-gray-900`}>{value}</span>
    </div>
  );
};

export default DetailItem;


